export default class PopupHandler {

    constructor(
        apiUrl,
        popupId,
        localStorageName,
        afterDelay = false,
        copyToEmail = '',
        templateName = 1,
        recaptchaSubmitFnName = 'recaptchaSubmitFn',
    ) {

        this.URL = apiUrl;
        this.popupId = popupId;
        this.popup = document.getElementById(popupId);
        this.localStorgeName = localStorageName;
        this.afterDelay = afterDelay;
        this.copyToEmail = copyToEmail;
        this.templateName = templateName;
        this.recaptchaFnName = recaptchaSubmitFnName;
        this.captchaValidationFired = false;
        this.form = document.querySelector(`#${popupId} form`);

    }

    init() {
        this.checkBeforeRender();
    }

    checkBeforeRender() {
        if (this.popup) {
            this.setCaptcha();
            this.observeCaptcha();
            this.attachEvents();
        }
    }

    observeCaptcha() {
        const domObserver =  new MutationObserver(() => {
            const iframe = document.querySelector("iframe[src^=\"https://www.google.com/recaptcha\"][src*=\"bframe\"]");

            if (iframe) {
                const captchaBackground = iframe.parentNode?.parentNode?.firstChild;
                captchaBackground?.addEventListener("click", () => this.bgcCaptchaHandle());
            }
        });

        domObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
    }

    attachEvents() {
        const closeBtn = document.querySelector(`#${this.popupId} [data-name="closeBtn"]`);

        if (this.afterDelay) {
            this.showPopupAfterDelay();
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', () => this.closePopup());
        }

        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                const phoneLength = document.querySelector(`#${this.popupId} input[type="tel"]`).value.length;

                if (phoneLength > 5) {
                    this.handleElementsShow('add');
                    this.runCaptcha();
                    if (!this.captchaValidationFired) {
                        this.sendAfterCaptchaValidation();
                    }
                }
            });
        }
    }

    showPopupAfterDelay() {

        if (!window.localStorage.getItem(`${this.localStorgeName}`)) {
            window.addEventListener('load', () => {
                setTimeout(() => {
                    this.popup.classList.add('active');
                }, 5000);
            });
        }
    }

    closePopup() {
        const wontSend = document.querySelector(`#${this.popupId} .alert`)?.classList.contains('d-none');

        if (wontSend) {
            this.saveLocalStorage();
        }

        this.popup.classList.remove('active');
    }

    saveLocalStorage() {
        window.localStorage.setItem(`${this.localStorgeName}`, 'true');
    }

    startSending() {
        this.handleSpinnerShow('remove');
    }

    setCaptcha() {
        window[this.recaptchaFnName] = (token) => {
            const responseInputList = document.querySelectorAll(`[data-response-token]`);
            responseInputList.forEach(responseInput => {
                responseInput.dataset.responseToken = token;
            });
        };
    }

    runCaptcha() {
        grecaptcha.execute();
    }

    sendAfterCaptchaValidation() {
        this.captchaValidationFired = true;
        let timer = 0;

        const interval = setInterval(() => {
            timer++;
            const response = document.querySelector(`#${this.popupId} [data-response-token]`).dataset.responseToken;

            if (response) {
                clearInterval(interval);
                timer = false;
                this.startSending();
                this.sendForm(response);
                this.resetCaptcha();
            }

            if (timer === 120 && !response) {
                clearInterval(interval);
                this.resetCaptcha();
                this.captchaValidationFired = false;
                setTimeout(()=> {
                    this.handleElementsShow('remove');
                }, 3000);
            };


        }, 1000);
    }

    resetCaptcha() {
        grecaptcha.reset();
        const responseInput = document.querySelector(`#${this.popupId} [data-response-token]`);
        responseInput.dataset.responseToken = '';
    }
    bgcCaptchaHandle() {
        this.resetCaptcha();
        setTimeout(() => {
            this.handleElementsShow('remove');
        }, 3000);
    }

    sendForm(response) {
        const phoneNumber = document.querySelector(`#${this.popupId} input[type="tel"]`).value;
        const approval = document.querySelector(`#${this.popupId} input[type="checkbox"]`).checked;
        const pageLang = document.documentElement.lang === 'pl' ? 'pl' : 'en';

        fetch(this.URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            mode: 'cors',
            body: JSON.stringify({
                language: pageLang,
                copyToUserEmail: this.copyToEmail,
                templateName: this.templateName,
                templateParameters: {
                    heading: window.location.href,
                    body: {
                        phone: phoneNumber,
                        approval: approval
                    }
                },
                gRecaptchaResponse: response
            })
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                this.handleSpinnerShow('add');
                this.showAlert('danger', 'errorInfo');
                throw Error(response.statusText);
            })
            .then (response => {
                if (response) {
                    this.showSuccessView();
                    this.saveLocalStorage();
                } else {
                    this.showAlert('danger', 'captchaInfo');
                }
            })
            .catch(error => {
                console.log(error + ' something went wrong');
                this.showAlert('danger', 'errorInfo');
            });
    }

    handleSpinnerShow(toggler) {
        const spinner = document.querySelector(`#${this.popupId} .spinner`);

        if (spinner) {
            spinner.classList[toggler]('d-none');
        }
    }

    handleElementsShow(toggler) {
        const elements = document.querySelectorAll(`#${this.popupId} [data-name='hideBeforeAlert']`);

        if (elements) {
            elements.forEach(el => el.classList[toggler]('d-none'));
        }
    }

    showSuccessView() {
        const { successHeading, successText } = this.popup.dataset
        const successMessage = document.createElement('div')
        const contentWrapper =  this.popup.querySelector('.container')
        const template = `
             <i class="icon-success text-color-1 fs-32 mb-24"></i>
             <h4>
                 ${successHeading}
             </h4>
             <p class="talks-popup-success-info">
                ${successText}
            </p>
        `
        successMessage.className = 'd-flex flex-column text-center align-self-center'
        successMessage.innerHTML = template

        this.form.remove()
        contentWrapper.appendChild(successMessage)
        contentWrapper.className+= ' d-flex justify-content-center h-100'
    }

    showAlert(alertType, dataName) {
        const alert = document.querySelector(`#${this.popupId} .alert`);

        if (alert) {
            const infoText = alert.dataset[dataName];

            this.handleElementsShow('add');
            this.handleSpinnerShow('add');

            alert.innerHTML =
                `
                    <div class="icon" aria-hidden="true"></div>
                    ${infoText}
                `;
            alert.classList.add(`alert-${alertType}`);
            alert.classList.remove('d-none');
        }
    }

}
